import React from "react";
import Text, { TextProps } from "./Text";

export default function Span(props: TextProps) {
  return <Text tag="span" {...props} />;
}
